import { render, staticRenderFns } from "./DashboardTops.vue?vue&type=template&id=3661e7d4&scoped=true"
import script from "./DashboardTops.vue?vue&type=script&lang=js"
export * from "./DashboardTops.vue?vue&type=script&lang=js"
import style0 from "./DashboardTops.vue?vue&type=style&index=0&id=3661e7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3661e7d4",
  null
  
)

export default component.exports